import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { User } from "../../models";

const initialState: { users: User[] } = {
  users: [],
};

export const usersSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    clearUsers: () => {
      return initialState;
    },
    setUsers: (state, action: PayloadAction<User[]>) => {
      state.users = action.payload;
    },
    updateUser: (state, action: PayloadAction<User>) => {
      const index = state.users.findIndex(
        (user) => user.id === action.payload.id
      );
      state.users[index] = action.payload;
    },
  },
});

export const { setUsers, updateUser, clearUsers } = usersSlice.actions;

export default usersSlice.reducer;
